import { useState, useEffect } from "react";
import moment from "moment";
import "moment/locale/es";
import styles from "./WeekSelector.module.css";

moment.locale("es");

const sameWeek = (a, b) =>
  a && b && a.start === b.start && a.end === b.end;

const WeekSelector = ({ onWeekChange, externalWeek, isMobile }) => {
  const [currentMonday, setCurrentMonday] = useState(moment().startOf("isoWeek"));

  useEffect(() => {
    if (!externalWeek?.start) return;
    const external = moment(externalWeek.start).startOf("isoWeek");
    if (!external.isSame(currentMonday, "day")) {
      setCurrentMonday(external);
    }
  }, [externalWeek, currentMonday]);

  useEffect(() => {
    if (!onWeekChange) return;
    const start = currentMonday.format("YYYY-MM-DD");
    const end = moment(currentMonday).endOf("isoWeek").format("YYYY-MM-DD");
    const next = { start, end };
    if (!sameWeek(externalWeek, next)) onWeekChange(next);
  }, [currentMonday]);

  const startDay = currentMonday.date();
  const endDay = moment(currentMonday).endOf("isoWeek").date();
  const startMonth = currentMonday.format("MMMM");
  const endMonth = moment(currentMonday).endOf("isoWeek").format("MMMM");
  const displayedMonth = startMonth === endMonth ? startMonth : `${endMonth}`;

  return (
    <div className={isMobile ? styles.wrapperMobile : styles.wrapper}>
      <div className={styles.titleBlock}>
        <h2 className={styles.title}>Control horario</h2>
        {isMobile ? (
          <p className={styles.subtitle}>
            Semana del{" "}
            <span className={styles.subtitleWeek}>
              {`${startDay} al ${endDay} de ${displayedMonth}`}
            </span>
          </p>
        ) : (
          <p className={styles.subtitle}>
            Este es tu horario para la semana del{" "}
            <span className={styles.subtitleWeek}>
              {`${startDay} al ${endDay} de ${displayedMonth}`}
            </span>
          </p>
        )}
      </div>
    </div>
  );
};

export default WeekSelector;
